"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { useOverlayContext, overlayContext } from './context.mjs';

const OverlayContextProvider = (props) => {
  const { type, controller, children } = props;
  const parentContext = useOverlayContext();
  return /* @__PURE__ */ jsx(
    overlayContext.Provider,
    {
      value: {
        ...parentContext,
        [type]: controller
      },
      children
    }
  );
};

export { OverlayContextProvider, OverlayContextProvider as default };
//# sourceMappingURL=OverlayContextProvider.mjs.map
